<template>
  <div class="home">
    <section class="card_section">
      <div class="container text-center">
        <div class="row justify-content-center">
          <h4 class="top-heading">Confirm you ship</h4>
          <template v-if="'img' in ship.data">
            <a href="JavaScript:void(0)"
              ><img
                v-show="isImageLoaded"
                :src="getImgUrl(ship.data.img)"
                alt="{{ship.data.name}}"
                @load="loaded"
            /></a>
            <img
              v-if="!isImageLoaded"
              class="w-100"
              :src="'/lostsailor/images/loader.gif'"
            />
          </template>
          <template v-if="'video' in ship.data">
            <video class="badge-item-stat-video h-10" autoplay loop muted>
              <source :src="getImgUrl(ship.data.video, 1)" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </template>
          <div class="d-flex justify-content-center">
            <a href="/dashboard" class="text-center position-relative">
              <h3 class="text-center pulse loginBtn">Back</h3>
            </a>
            <a
              href="#"
              class="text-center position-relative"
              @click.prevent="getReady()"
            >
              <h3 class="text-center pulse loginBtn">Ready</h3>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import router from "@/router";
import ApiService from "@/services";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "Ready",
  data() {
    return {
      countryStrokeColor: "#fa0909",
      legendBorderRadius: 1,
      isImageLoaded: false,
      showReadyButton: false,
      location: null,
      authenticator: null,
    };
  },
  computed: mapState([
    // map this.count to store.state.count
    "ship",
  ]),
  async created() {
    if (localStorage.getItem("selectedShip")) {
      const ship = JSON.parse(localStorage.getItem("selectedShip"))[0];
      this.$store.commit("addShip", ship);
    } else {
      await ApiService.getShip((ship) => this.$store.commit("addShip", ship));
    }
  },
  mounted() {
    if (!localStorage.getItem("wax_user")) {
      router.push("/login");
    }
    this.authenticator = localStorage.getItem("ual-session-authenticator");
  },
  methods: {
    loaded() {
      this.isImageLoaded = true;
    },
    getImgUrl(pet, isVid) {
      return ApiService.getImgUrl(pet, isVid);
    },
    async getReady() {
      await ApiService.setShip(this.ship.asset_id, (res) => {
        if (res.processed) {
          toast.success("Ship set, you are ready");
          router.push("/race");
        }
      });
    },
    async resetShip() {
      await ApiService.resetShip(this.ship.selectedShip.id, (res) => {
        if (res.processed) {
          toast.success("Ship Reset");
          router.push("/");
        }
      });
    },
  },
};
</script>
<style scoped>
.content {
  height: 70%;
}
.select-card {
  width: 160px;
  position: absolute;
}
a {
  text-decoration: none !important;
}
.card {
  box-shadow: -1px 8px 19px 4px rgba(0, 0, 0, 0.3);
}
.select-btn {
  border: 1px solid gray;
  width: 100px;
  text-align: center;
  height: 36px;
  margin: 0 auto;
  font-size: 20px;
  color: #fff;
  border-radius: 10px;
  line-height: 30px;
}

</style>